<template>
  <div class="container">
    <head-nav-bar :title="title" :fixed="true" @click-left="$router.go(-1)" />
    <div class="mt-header-nav">
      <div class="kong"></div>
      <van-cell-group>
        <van-field
          v-model="form.cardholderName"
          required
          clearable
          label="患者姓名："
          placeholder="请输入真实姓名"
          readonly
          @blur="onNameChange"
        />
      </van-cell-group>
      <div class="kong"></div>
      <!-- 添加类型=1显示在前面 -->
      <div v-if="addType != 2">
        <van-cell-group>
          <van-field
            v-model="form.identityDocTypeDesc"
            readonly
            class="readonly"
            label="证件类型："
            placeholder="点击此处选择"
            @click="showCredType"
          />
        </van-cell-group>

        <van-cell-group>
          <van-field
            v-model="form.identityDocNo"
            class="readonly"
            label="证件号码："
            clearable
            placeholder="点击输入"
            :error-message="idCardErrorMsg"
            @blur="onIdentityDocNoChange"
            @change="idCardChange = true"
          />
        </van-cell-group>
        <div class="kong"></div>
      </div>
      <van-cell-group>
        <van-field
          v-model="form.cardTypeDesc"
          readonly
          label="卡类型："
          :disabled="form && form.id ? true : false"
          class="readonly"
          placeholder="点击此处选择"
          @click="showSelectCardType"
        />
      </van-cell-group>

      <van-cell-group>
        <van-field
          v-model="form.cardNo"
          label="就诊卡号："
          required
          :disabled="form && form.id ? true : false"
          clearable
          placeholder="点击输入"
          @blur.stop="onCardNoChange"
        />
      </van-cell-group>

      <div class="kong"></div>
      <!-- 添加类型=2显示在后面 -->
      <div v-if="addType == 2">
        <van-cell-group>
          <van-field
            v-model="form.identityDocTypeDesc"
            readonly
            class="readonly"
            label="证件类型："
            placeholder="点击此处选择"
            @click="showCredType"
          />
        </van-cell-group>

        <van-cell-group>
          <van-field
            v-model="form.identityDocNo"
            class="readonly"
            label="证件号码："
            clearable
            placeholder="点击输入"
            :error-message="idCardErrorMsg"
            @blur="onIdentityDocNoChange"
            @change="idCardChange = true"
          />
        </van-cell-group>
        <div class="kong"></div>
      </div>
      <van-cell-group>
        <van-field
          v-model="form.relationTypeDesc"
          readonly
          class="readonly"
          label="与本人关系："
          placeholder="点击此处选择"
          @click="showRelation"
        />
      </van-cell-group>

      <van-cell-group>
        <van-field
          v-model="form.cardholderBirthDate"
          readonly
          required
          label="出生日期："
          placeholder="点击此处选择"
          @click="showSelectDate"
        />
      </van-cell-group>

      <van-cell-group>
        <van-field
          v-model="form.cardholderSexName"
          readonly
          class="readonly"
          label="性别："
          placeholder="点击此处选择"
          @click="showSelectSex"
        />
      </van-cell-group>

      <van-cell-group>
        <van-field
          v-model="form.cardholderContactPhone"
          label="手机号码："
          clearable
          required
          placeholder="点击输入"
          :error-message="mobilePhoneErrorMsg"
          @blur="onMobilePhoneChange"
          @change="phoneChange = true"
        />
      </van-cell-group>

      <div class="kong"></div>

      <van-notice-bar wrapable :scrollable="false">
        本院为实名制就诊,为保障您的权益,请如实填写就诊人信息.若输入正确姓名、身份证、就诊卡号仍无法绑定，请前往线下人工收费窗口办理。<br />每位微信用户可以最多绑定6张卡
      </van-notice-bar>

      <div class="box" style="margin-top: 0.5rem">
        <van-button
          type="info"
          block
          :disabled="disabled"
          :loading="loading"
          @click="onSubmit"
          >确认绑定</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  Field,
  Cell,
  CellGroup,
  NoticeBar,
  Button,
  Toast,
  Notify,
  Dialog,
} from "vant";
import SelectPicker from "@/components/select-picker/function";
import DateTimePicker from "@/components/date-time-picker/function";
import {
  getSelectData,
  cache,
  IdentityCodeValid,
  checkPhone,
} from "@/utils/common";
export default {
  name: "userContactInfo",
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [NoticeBar.name]: NoticeBar,
    [Button.name]: Button,
  },
  data() {
    return {
      idCardChange: false,
      phoneChange: false,
      cardholderContactPhone: "",
      identityDocNo: "",
      title: "添加就诊人",
      selectData: {},
      disabled: false,
      idCardErrorMsg: "",
      mobilePhoneErrorMsg: "",
      selectPickerModal: "",
      loading: false,
      form: {
        id: 0,
        relationType: "5",
        relationTypeDesc: "本人",
        identityDocTypeDic: "10",
        identityDocTypeDesc: "居民身份证",
        identityDocNo: "",
        cardholderName: "",
        cardNo: "",
        cardholderBirthDate: "",
        cardholderSex: "",
        cardholderSexName: "",
        cardholderContactPhone: "",
        cardType: "12",
        cardTypeDesc: "就诊卡",
        cardholderAddress: "",
      },
      addType: "1",
    };
  },
  created() {
    this.init();
  },
  beforeDestroy() {
    this.selectPickerModal && this.selectPickerModal.cancel();
  },
  methods: {
    init() {
      this.form.id = this.$route.query.id;
      this.addType = this.$route.query.type ? this.$route.query.type : 1;

      getSelectData([
        "RelationType",
        "IdentityDocTypeDic",
        "CardType",
        "SexType",
      ]).then(res => {
        this.selectData = res;
        if (this.form.id) {
          this.title = "编辑就诊人";
          this.getInfo();
        } else {
          this.title = "添加就诊人";
          if (
            this.addType == 1 &&
            this.$route.query.identityNo &&
            this.$route.query.name
          ) {
            this.form.cardholderName = this.$route.query.name;
            this.form.identityDocNo = this.$route.query.identityNo;

            this.checkPersonInfo({
              identityNo: this.$route.query.identityNo,
              name: this.$route.query.name,
            });
          } else if (
            this.addType == 2 &&
            this.$route.query.diagnosisCardNo &&
            this.$route.query.name
          ) {
            this.form.cardholderName = this.$route.query.name;
            this.form.cardNo = this.$route.query.diagnosisCardNo;
            this.form.diagnosisCardNo = this.$route.query.diagnosisCardNo;
            this.checkPersonInfo({
              diagnosisCardNo: this.$route.query.diagnosisCardNo,
              name: this.$route.query.name,
            });
          }
        }
      });
    },
    getInfo() {
      this.$post("Contact_Info", { id: this.form.id })
        .then(res => {
          this.cardholderContactPhone = res.data.cardholderContactPhone;
          this.identityDocNo = res.data.identityDocNo;
          res.data.cardholderContactPhone = this.editStringCardholderContactPhone(
            res.data.cardholderContactPhone,
            "edit",
          );
          res.data.identityDocNo = this.editStringIdentityDocNo(
            res.data.identityDocNo,
            "edit",
          );
          if (res.data.cardholderContactAddress) {
            res.data.cardholderAddress = res.data.cardholderContactAddress;
          }
          this.form = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    editStringIdentityDocNo(str, edit) {
      const after = str.substr(0, 3);
      const backLength = str.length - 7;
      const back4Number = str.substr(str.length - 4, str.length);
      let asterisk = "";
      if (edit == "edit") {
        for (let index = 0; index < backLength; index++) {
          asterisk += "*";
        }
        return after + asterisk + back4Number;
      } else {
        return this.identityDocNo;
      }
    },
    editStringCardholderContactPhone(str, edit) {
      const after = str.substr(0, 3);
      const backLength = str.length - 7;
      const back4Number = str.substr(str.length - 4, str.length);
      let asterisk = "";
      if (edit == "edit") {
        for (let index = 0; index < backLength; index++) {
          asterisk += "*";
        }
        return after + asterisk + back4Number;
      } else {
        return this.cardholderContactPhone;
      }
    },
    showRelation() {
      const _this = this;
      this.selectPickerModal = SelectPicker({
        columns: this.selectData.RelationType,
        defaultValue: this.form.relationType,
        change: data => {
          _this.form.relationType = data.id;
          _this.form.relationTypeDesc = data.Text;
        },
      });
    },
    showCredType() {
      const _this = this;
      this.selectPickerModal = SelectPicker({
        columns: this.selectData.IdentityDocTypeDic,
        defaultValue: this.form.identityDocTypeDic,
        change: data => {
          _this.form.identityDocTypeDic = data.id;
          _this.form.identityDocTypeDesc = data.text;
          console.log(this.form);
        },
      });
    },

    showSelectDate() {
      const time = this.form.cardholderBirthDate
        ? this.form.cardholderBirthDate
        : "2000-01-01";
      this.selectPickerModal = DateTimePicker({
        value: time,
        format: "yyyy-MM-dd",
        change: this.setBirthday,
      });
    },
    setBirthday(data) {
      this.form.cardholderBirthDate = data;
    },

    showSelectSex() {
      this.selectPickerModal = SelectPicker({
        columns: this.selectData.SexType,
        defaultValue: this.form.cardholderSex,
        change: data => {
          this.form.cardholderSex = data.id;
          this.form.cardholderSexName = data.text;
        },
      });
    },

    showSelectCardType() {
      const _this = this;
      if (this.form.id) {
        Notify("此类型不能修改！");
        return false;
      }
      this.selectPickerModal = SelectPicker({
        columns: this.selectData.CardType,
        defaultValue: this.form.cardType,
        change: data => {
          _this.form.cardType = data.id;
          _this.form.cardTypeDesc = data.text;
        },
      });
    },
    onIdentityDocNoChange(e) {
      const value = e.target.value;
      if (value) {
        const verifyIdCard = IdentityCodeValid(value);
        if (this.addType == 1 && this.form.cardholderName) {
          if (
            this.form.identityDocTypeDic == "10" &&
            verifyIdCard &&
            verifyIdCard.state !== "success"
          ) {
            this.idCardErrorMsg = verifyIdCard.msg;
          } else {
            this.idCardErrorMsg = "";
            this.checkPersonInfo({
              identityNo: value,
              name: this.form.cardholderName,
            });
          }
        } else if (this.form.identityDocTypeDic == "10") {
          if (verifyIdCard && verifyIdCard.state === "success") {
            // 自动填写 生日 性别
            this.form.cardholderSex = verifyIdCard.sex;
            this.form.cardholderSexName = verifyIdCard.sex == 1 ? "男" : "女";
            this.form.cardholderBirthDate = verifyIdCard.birthday;
            this.idCardErrorMsg = "";
          } else {
            this.idCardErrorMsg = verifyIdCard.msg;
          }
        }
      }
    },
    onMobilePhoneChange(e) {
      const value = e.target.value;
      if (value) {
        const verifyPhone = checkPhone(value);
        if (!verifyPhone) {
          this.mobilePhoneErrorMsg = "手机号码格式有误！";
        } else {
          this.mobilePhoneErrorMsg = "";
        }
      }
    },
    onCardNoChange(e) {
      e.stopPropagation();
      e.srcElement.blur();
      const value = e.target.value;
      if (value && this.addType == 2 && this.form.cardholderName) {
        this.checkPersonInfo({
          diagnosisCardNo: value,
          name: this.form.cardholderName,
        });
      }
    },
    onNameChange(e) {
      e.stopPropagation();
      e.srcElement.blur();
      const value = e.target.value;
      const { form } = this;
      if (!value) {
        return false;
      }
      let json = {
        Name: value,
      };
      if (this.addType == 1 && form.identityDocNo) {
        json.identityNo = form.identityDocNo;
      } else if (this.addType == 2 && form.cardNo) {
        json.diagnosisCardNo = form.cardNo;
      } else {
        return;
      }
      this.checkPersonInfo(json);
    },
    checkPersonInfo(json) {
      this.$post("His_PersonInfo", json)
        .then(res => {
          const CardData = res.data;
          if (CardData && CardData.diagnosisCardNo) {
            if (!this.form.cardholderContactPhone) {
              this.form.cardholderContactPhone = CardData.mobilePhone;
            }
            if (!this.form.diagnosisCardNo) {
              this.form.cardNo = CardData.diagnosisCardNo;
            }
            if (!this.form.identityDocNo) {
              this.form.identityDocNo = CardData.identityNo;
            }
            if (!this.form.cardholderBirthDate) {
              this.form.cardholderBirthDate = CardData.birthday;
            }
            if (!this.form.cardholderSexName) {
              const sexFind = this.selectData.SexType.find(
                p => p.text == CardData.sex,
              );
              if (sexFind && sexFind.id) {
                this.form.cardholderSex = sexFind.id;
                this.form.cardholderSexName = sexFind.text;
              }
            }
            if (!this.form.cardholderAddress) {
              this.form.cardholderAddress = CardData.contactAddress;
            }

            this.verifyCardBind(CardData.diagnosisCardNo);
          }
        })
        .catch(() => {
          if (this.addType == 1) {
            this.form.identityDocNo = "";
          } else if (this.addType == 2) {
            this.form.cardNo = "";
          }
        });
    },
    verifyCardBind(cardNo) {
      this.$post("VerifyCardBind", {
        DiagnosisCardNo: cardNo,
      }).then(res => {
        if (res.data) {
          //已绑定过的卡号
          Dialog.alert({
            title: "提示",
            message: "该卡已绑定过就诊人，请输入其它卡号绑定",
          }).then(() => {
            // this.form.CardNo = "";
          });
          return false;
        }
      });
    },

    onSubmit() {
      //验证
      const verifyRes = this.verifyForm();
      if (verifyRes === false) {
        return false;
      }

      this.verifyCard().then(() => {
        let cardholderContactPhone = "";
        if (this.form.cardholderContactPhone.indexOf("*") != -1) {
          cardholderContactPhone = this.editStringCardholderContactPhone(
            this.form.cardholderContactPhone,
            "submit",
          );
        } else {
          cardholderContactPhone = this.form.cardholderContactPhone;
        }
        let identityDocNo = "";
        if (this.form.identityDocNo.indexOf("*") != -1) {
          identityDocNo = this.editStringIdentityDocNo(
            this.form.identityDocNo,
            "submit",
          );
        } else {
          identityDocNo = this.form.identityDocNo;
        }

        this.form = {
          ...this.form,
          cardholderSex: String(this.form.cardholderSex),
          DiagnosisCardNo: this.form.cardNo,
        };
        let api = "Contact_Add";
        let msg = "添加就诊人成功！";
        if (this.form.id) {
          api = "Contact_Edit";
          msg = "修改就诊人成功！";
        }
        this.loading = true;
        this.$post(api, {
          ...this.form,
          cardholderContactPhone: cardholderContactPhone,
          identityDocNo: identityDocNo,
        })
          .then(() => {
            Toast.success(msg);
            cache.set("currentContact", this.form);
            this.loading = false;
            this.$router.push({ name: "userContactList", replace: true });
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    verifyForm() {
      const verifyFields = [
        "cardholderName",
        "cardholderBirthDate",
        "cardholderSexName",
        "cardholderContactPhone",
        "cardNo",
        "identityDocNo",
      ];
      let is = false;
      for (let i = 0; i < verifyFields.length; i++) {
        const item = verifyFields[i];
        if (!this.form[item]) {
          is = true;
        }
      }
      if (is) {
        Notify("带*号必填，请完善信息！");
        return false;
      }
      if (!checkPhone(this.form.cardholderContactPhone) && this.phoneChange) {
        Notify("手机号码格式有误！");
        return false;
      }

      if (this.form.identityDocTypeDic == "10") {
        const verifyIdCard = IdentityCodeValid(this.form.identityDocNo);
        if (
          verifyIdCard &&
          verifyIdCard.state !== "success" &&
          this.idCardChange
        ) {
          Notify(verifyIdCard.msg);
          return false;
        }
        if (
          verifyIdCard.birthday &&
          this.form.cardholderBirthDate != verifyIdCard.birthday
        ) {
          Notify("身份证生日与出生日期不一致");
          return false;
        }
      }
      return true;
    },

    verifyCard() {
      return new Promise((resolve, reject) => {
        this.$post("His_PersonInfo", {
          DiagnosisCardNo: this.form.cardNo,
          Name: this.form.cardholderName,
        })
          .then(res => {
            const CardData = res.data;
            if (
              CardData &&
              CardData.patientName &&
              CardData.patientName !== this.form.cardholderName
            ) {
              Notify("姓名与就诊卡信息不相符，请重新输入！");
              reject();
            } else if (
              CardData &&
              CardData.identityNo &&
              this.form.identityDocNo.indexOf("*") == -1 &&
              CardData.identityNo !== this.form.identityDocNo
            ) {
              Notify("身份证号与就诊卡信息不相符，请重新输入！");
              reject();
            } else {
              resolve();
            }
          })
          .catch(() => {});
      });
    },
  },
};
</script>

<style></style>
